export const svgTooltipConfig = {
	fontSize: 2,
	// top, right, bottom, left
	padding: [0.75, 1.5, 0.75, 1.5]
};
